/**
 * CR V3 H5 参会端路由（匿名，无布局）
 */

import type { RouteRecordRaw } from 'vue-router'
import { crV3JoinSessionBeforeEnter } from '@/modules/cr-v3-viewer/router/cr-v3-join-route-guard'

export const crV3H5Route: RouteRecordRaw = {
  path: '/cr-v3/h5/:code',
  name: 'CrV3H5',
  component: () => import('@/modules/cr-v3-viewer/views/CrV3H5View.vue'),
  beforeEnter: crV3JoinSessionBeforeEnter,
  props: true,
  meta: {
    title: '智慧课堂',
    requiresAuth: false,
    hidden: true,
  },
}

export default crV3H5Route
